<template>
  <div class="edit-riseupgoal-amount-popup">
    <popup :buttons="buttonOptions"
           :closeAction="close">
      <template v-slot:title>
        <span>יעד riseup</span>
      </template>
      <template v-slot:content>
        <span>הסכום שתגדירו הוא הכסף</span>
        <span class="bold">שצפוי להשאר בסוף החודש</span>
        <span>אם תעמדו בהוצאות המשתנות.</span>
        <edit-amount-input :updated-amount="updatedAmount" :onInput="onInput"/>
        <div class="error-container">
          <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
        </div>
        <progress-bar :left-amount="totalAmount"
                      :left-label="'יתרת הוצאות משתנות'"
                      :right-label="'כמה לשים בצד?'"
                      :right-amount="updatedAmount"
                      :cashflow-category="cashflowCategory" />
        <div class="left">ישארו
          <span>{{ variablesLeft }}</span>
          <span>₪</span>
          להוצאות משתנות החודש</div>
      </template>
    </popup>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions, mapState } from 'vuex';
import BaseUI from 'base-ui';
import cashflowViewConsts from '@/constants/cashflow-view';
import EventBus from '@/event-bus/event-bus';
import RiseupGoalUpdatedToaster
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/toasters/RiseupGoalUpdatedToaster';
import ProgressBar from '../../../../generic-components/cashflow-types/cashflow-types-base/ProgressBar.vue';
import Segment from '../../../../../../../../../../Segment';
import moneyUtils from '../../../../../../../../../../utils/money';

export default {
  name: 'EditRiseupGoalAmount',
  components: {
    Popup: BaseUI.Popup,
    EditAmountInput: BaseUI.EditAmountInput,
    ProgressBar,
  },
  props: {
    onSaveCb: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      updatedAmount: null,
      errorMsg: '',
    };
  },
  created() {
    Segment.trackUserInteraction('EditRisepGoalAmount_Shown');
    this.updatedAmount = _.round(this.riseupGoal);
  },
  computed: {
    ...mapGetters('cashflowView', ['riseupGoal', 'remainingVariables']),
    ...mapState('cashflowView', ['presentedBudgetDate']),
    cashflowCategory() {
      return cashflowViewConsts.CASHFLOW_CATEGORIES.VARIABLE;
    },
    buttonOptions() {
      return [{
        title: 'עדכון יעד riseup',
        size: 'slim',
        action: () => this.onSave(),
        variant: 'primary',
      }];
    },
    totalAmount() {
      return _.max([this.remainingVariables, 0]) + this.riseupGoal;
    },
    variablesLeft() {
      return moneyUtils.formatAmountWithFraction(this.totalAmount - this.updatedAmount, 1);
    },
    ERROR_MESSAGES() {
      return {
        LESS_THAN_ACTUAL_SUM: 'הסכום צריך להיות נמוך מיתרת ההוצאות המשתנות',
      };
    },
  },
  methods: {
    ...mapActions('editCashflow', ['updateRiseupGoal']),
    close() {
      Segment.trackUserInteraction('EditRisepGoalAmount_CloseClicked');
      this.$emit('close');
    },
    triggerOnSaveCb() {
      if (!!this.onSaveCb && typeof this.onSaveCb === 'function') {
        this.onSaveCb();
      }
    },
    onSave() {
      if (!this.errorMsg) {
        Segment.trackUserInteraction('EditRisepGoalAmount_SaveClicked');
        this.triggerOnSaveCb();
        this.updateRiseupGoal({ budgetDate: this.presentedBudgetDate, previousAmount: this.riseupGoal, amount: this.updatedAmount });
        this.close();
      }
      EventBus.$emit('open-toaster', {
        component: RiseupGoalUpdatedToaster,
        props: {},
      });
    },
    onInput(value) {
      if (value > this.totalAmount) {
        this.errorMsg = this.ERROR_MESSAGES.LESS_THAN_ACTUAL_SUM;
      } else {
        this.errorMsg = '';
        this.updatedAmount = value;
      }
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .edit-riseupgoal-amount-popup {

    .bold {
      font-weight: bold;
    }

    .content {
      line-height: 1.4;
    }

    .goal-text {
      @include category-color;
    }

    .edit-amount-input {
      padding: 26px 0px 0px 0px;
    }

    .error-container {
      padding-bottom: 26px;
      position: relative;

      .error-message {
        position: absolute;
        top: -6px;
        color: $riseup_danger_red;
        font-size: 10px;
        font-family: SimplerPro;
        font-weight: bold;
      }
    }

    .expense-progress-bar-container {
      margin-bottom: 0px;

      .progress-bar-numbers {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 12px;

        .up-to-now {
          .name.pending {
            color: $riseup_yellow;
          }
          .amount .spacer {
            display: none;
          }
        }

        .recommended.pending {
          color: $riseup_black;

          .amount .spacer {
            display: none;
          }
        }
      }
    }

    .left {
      font-size: 12px;
      font-weight: bold;
      margin-top: 15px;
    }

    .riseup-button {
      margin: 16px 0px;
    }
  }

</style>
